/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autoreplies_SentInputs */

const en_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-Replies sent`)
};

const es_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas automáticas enviadas`)
};

const fr_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponses automatiques envoyées`)
};

const de_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesendete automatische Antworten`)
};

const ja_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信済みの自動返信`)
};

const zh_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发送自动回复`)
};

const ar_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ردود آلية مرسلة`)
};

const id_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balasan Otomatis terkirim`)
};

const it_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposte Automatiche Inviate`)
};

const ru_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправлено автоответов`)
};

const pt_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas automáticas enviadas`)
};

const ko_autoreplies_sent = /** @type {(inputs: Autoreplies_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전송된 자동 회신`)
};

/**
* | output |
* | --- |
* | "Auto-Replies sent" |
*
* @param {Autoreplies_SentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const autoreplies_sent = /** @type {((inputs?: Autoreplies_SentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autoreplies_SentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autoreplies_sent(inputs)
	if (locale === "es") return es_autoreplies_sent(inputs)
	if (locale === "fr") return fr_autoreplies_sent(inputs)
	if (locale === "de") return de_autoreplies_sent(inputs)
	if (locale === "ja") return ja_autoreplies_sent(inputs)
	if (locale === "zh") return zh_autoreplies_sent(inputs)
	if (locale === "ar") return ar_autoreplies_sent(inputs)
	if (locale === "id") return id_autoreplies_sent(inputs)
	if (locale === "it") return it_autoreplies_sent(inputs)
	if (locale === "ru") return ru_autoreplies_sent(inputs)
	if (locale === "pt") return pt_autoreplies_sent(inputs)
	return ko_autoreplies_sent(inputs)
});